export default defineNuxtRouteMiddleware((to, from) => {
  // console.log("I always run!");
});
